module.exports = __webpack_public_path__ + "static/media/announcement-destinations.393f513e.svg";